// Trims the `date-fns/locale` barrel down to en-US to keep 94 unused locales out of
// the bundle. rc-picker@2's picker adapter (rc-picker/lib/generate/dateFns) does
// `import * as Locale from "date-fns/locale"` and indexes it by a runtime-computed
// key, which defeats tree-shaking — so without this shim all 95 locales ship.
//
// Wired up via `resolve.alias` in vite.config.ts (exact match on "date-fns/locale").
// Add locales here if the pickers ever need to render in a non-en-US language.
//
// REMOVE when rc-picker no longer pulls the whole barrel — i.e. after upgrading antd
// (and its transitive rc-picker) to a version whose date-fns adapter imports locales
// individually, or after migrating BTDatePicker off the date-fns adapter (e.g. to
// dayjs). Verify with `madge`/a bundle build that no date-fns@2 locales remain, then
// delete this file and the alias.
export { enUS } from "date-fns/locale/en-US";
